import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { SpreadingState } from '@components/main/spreading/state/manager';
import { AutocompleteOption, Categorization, Row } from '@components/main/spreading/models/models';

@Component({
  selector: 'app-recategorize-modal',
  templateUrl: './recategorize-modal.component.html',
  styleUrls: ['./recategorize-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RecategorizeModalComponent implements AfterViewInit {
  @Input() state: SpreadingState;
  @Input() row: Row;
  @Input() viewInNativeLanguage = true;
  @Input() buttonElement: HTMLElement;

  @Output() stateChanged = new EventEmitter<SpreadingState>();
  @Output() closeModal = new EventEmitter<void>();

  @ViewChild('modalContainer', { static: false }) modalContainer: ElementRef;

  constructor(private cdr: ChangeDetectorRef) {}

  get isValidation(): boolean {
    return this.row?.categorizationType === 'validation';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.buttonElement && this.modalContainer) {
        this.positionModal();
      }
      this.focusSearchInput();
    }, 0);
  }

  private focusSearchInput(): void {
    const input = this.modalContainer?.nativeElement.querySelector(
      '.source-item-search-input'
    ) as HTMLElement | null;
    input?.focus();
  }

  private positionModal(): void {
    if (!this.buttonElement || !this.modalContainer) {
      return;
    }

    const buttonRect = this.buttonElement.getBoundingClientRect();
    const modalElement = this.modalContainer.nativeElement;
    const modalContent = modalElement.querySelector('.modal-content');

    if (!modalContent) {
      return;
    }

    // Position below and to the right of the button
    const top = buttonRect.bottom;
    const left = buttonRect.right;

    // Ensure modal doesn't go off screen
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const modalWidth = (modalContent as HTMLElement).offsetWidth || 300;
    const modalHeight = (modalContent as HTMLElement).offsetHeight || 200;

    let finalLeft = left;
    let finalTop = top;

    // Adjust if modal would go off right edge
    if (left + modalWidth > viewportWidth) {
      finalLeft = viewportWidth - modalWidth - 10;
    }

    // Adjust if modal would go off bottom edge
    if (top + modalHeight > viewportHeight) {
      finalTop = buttonRect.top - modalHeight; // Position above instead
    }

    modalElement.style.position = 'fixed';
    modalElement.style.top = `${finalTop}px`;
    modalElement.style.left = `${finalLeft}px`;
    modalElement.style.zIndex = '1050';
  }

  @HostListener('keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    event.preventDefault();
    this.onClose();
  }

  onItemSelected(option: AutocompleteOption): void {
    if (!this.state || !this.row || option?.id == null) {
      return;
    }
    const categorization: Categorization = {
      sourceRow: this.row,
      templateLineItemId: option.id,
      templateLineItemLabel: option.value ?? '',
      isValidation: this.isValidation,
    };
    this.state.categorizeRows([categorization]);
    this.stateChanged.emit(this.state);
    this.onClose();
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
